import React from 'react';

function BarTelegramIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      {...props}>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M0 0H30V30H0z"
              transform="translate(-1465 -643) translate(1465 643)"
            />
            <path
              fill="#3DB2FF"
              fillRule="nonzero"
              d="M6.338 13.557l15.963-6.478c.741-.281 1.388.19 1.148 1.37l.001-.002-2.718 13.476c-.2.956-.74 1.188-1.495.738l-4.14-3.21-1.996 2.024c-.22.232-.407.428-.834.428l.294-4.433 7.67-7.294c.335-.309-.074-.483-.514-.175l-9.48 6.281-4.087-1.341c-.887-.297-.906-.934.188-1.384z"
              transform="translate(-1465 -643) translate(1465 643)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BarTelegramIcon;
